<main class="not-found-page" aria-labelledby="not-found-title">
  <section class="not-found-card">
    <div class="not-found-copy">
      <p class="not-found-kicker">Page unavailable</p>
      <h1 id="not-found-title" #pageHeading tabindex="-1">
        We couldn’t find that page
      </h1>
      <p class="not-found-explanation">
        The page may have moved, or the address may be incorrect. Check the
        address, or use one of the options below.
      </p>

      <div class="not-found-actions" aria-label="Page recovery options">
        <a mat-flat-button matExpButton color="primary" routerLink="/">
          <mat-icon aria-hidden="true">home</mat-icon>
          Return home
        </a>
        @if (canGoBack) {
          <button mat-stroked-button matExpButton type="button" (click)="goBack()">
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
            Go back
          </button>
        }
      </div>

      <p class="not-found-help">
        Still need help? <a routerLink="/contact-us">Contact the SyRF team</a>.
      </p>
    </div>

    <div class="not-found-illustration" aria-hidden="true">
      <img
        src="/assets/images/not-found-document-route-v2.webp"
        alt=""
        width="1024"
        height="499"
        loading="lazy"
        decoding="async"
        fetchpriority="low"
      />
    </div>
  </section>
</main>
